// export enum UserRoles {
//     Admin = 'ROLE_ADMIN',
//     Owner = 'ROLE_OWNER',
//     Staff = 'ROLE_STAFF',
//     Member = 'ROLE_MEMBER',
// }

export enum NotificationType {
    Success = 'success',
    Error = 'error',
    Warning = 'warning',
    Info = 'info',
}

export enum StatCardIcon {
    USER = 'USER',
    CALENDAR = 'CALENDAR',
    HOUR_GLASS = 'HOUR_GLASS',
    DUMBBELL = 'DUMBBELL',
    STORE = 'STORE',
    MEMBERSHIP = 'MEMBERSHIP',
    DOLLER = 'DOLLER',
    ATTEND = 'ATTEND',
}

export enum MemberMessageType {
    PAYMENT_REMINDER = 'Payment Reminder',
    // DIET_PLAN = 'Diet Plan',
    // WORKOUT_SCHEDULE = 'Workout Schedule'
}

export enum BusinessMessageType {
    PAYMENT_REMINDER = 'Payment Reminder',
    GENERAL_ANNOUNCEMENT = 'General Announcement',
    // DIET_PLAN = 'Diet Plan',
    // WORKOUT_SCHEDULE = 'Workout Schedule'
}

export enum MessageStatus {
    QUEUED = 'queued',
    SENT = 'sent',
    DELIVERED = 'delivered',
    READ = 'read',
    FAILED = 'failed',
    UNDELIVERED = 'undelivered',
}

export enum MessageChannel {
    WHATSAPP = 'whatsapp',
    SMS = 'sms',
}

export enum PaymentCategory {
    MEMBERSHIP_FEE = 'membership_fee',
    REGISTRATION_FEE = 'registration_fee',
    LOGIN_FEE = 'login_fee',
}

export enum NoteStatus {
    OPEN = 'OPEN',
    In_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
}

export enum NoteTargetType {
    MEMBER = 'MEMBER',
    BUSINESS = 'BUSINESS',
    STAFF = 'STAFF',
    SELF = 'SELF',
}

export enum UserType {
    BUSINESS_USER = 'BUSINESS_USER',
    MEMBER = 'MEMBER',
    GYMINIFY = 'GYMINIFY',
}

export enum PermissionCode {
    // ROLE_ADMIN = 'ROLE_ADMIN',
    // ROLE_MEMBER = 'ROLE_MEMBER',
    // ROLE_OWNER = 'ROLE_OWNER',
    // ROLE_STAFF = 'ROLE_STAFF',
    MEMBERS_VIEW = 'MEMBERS_VIEW',
    MEMBERS_CREATE = 'MEMBERS_CREATE',
    MEMBERS_EDIT = 'MEMBERS_EDIT',
    MEMBERS_DELETE = 'MEMBERS_DELETE',
    MEMBER_LOGIN_MANAGE = 'MEMBER_LOGIN_MANAGE',
    MEMBER_ATTENDANCE_VIEW = 'MEMBER_ATTENDANCE_VIEW',
    MEMBER_ATTENDANCE_MARK = 'MEMBER_ATTENDANCE_MARK',
    MEMBER_ATTENDANCE_EDIT = 'MEMBER_ATTENDANCE_EDIT',
    MEMBER_ATTENDANCE_DELETE = 'MEMBER_ATTENDANCE_DELETE',
    MEMBERSHIPS_VIEW = 'MEMBERSHIPS_VIEW',
    MEMBERSHIPS_CREATE = 'MEMBERSHIPS_CREATE',
    MEMBERSHIPS_EDIT = 'MEMBERSHIPS_EDIT',
    MEMBERSHIPS_DELETE = 'MEMBERSHIPS_DELETE',
    WORKOUT_PLANS_VIEW = 'WORKOUT_PLANS_VIEW',
    WORKOUT_PLANS_CREATE = 'WORKOUT_PLANS_CREATE',
    WORKOUT_PLANS_EDIT = 'WORKOUT_PLANS_EDIT',
    WORKOUT_PLANS_DELETE = 'WORKOUT_PLANS_DELETE',
    EXERCISES_VIEW = 'EXERCISES_VIEW',
    EXERCISES_CREATE = 'EXERCISES_CREATE',
    EXERCISES_EDIT = 'EXERCISES_EDIT',
    EXERCISES_DELETE = 'EXERCISES_DELETE',
    NUTRITION_PLANS_VIEW = 'NUTRITION_PLANS_VIEW',
    NUTRITION_PLANS_CREATE = 'NUTRITION_PLANS_CREATE',
    NUTRITION_PLANS_EDIT = 'NUTRITION_PLANS_EDIT',
    NUTRITION_PLANS_DELETE = 'NUTRITION_PLANS_DELETE',
    MEAL_ITEMS_VIEW = 'MEAL_ITEMS_VIEW',
    MEAL_ITEMS_CREATE = 'MEAL_ITEMS_CREATE',
    MEAL_ITEMS_EDIT = 'MEAL_ITEMS_EDIT',
    MEAL_ITEMS_DELETE = 'MEAL_ITEMS_DELETE',
    NOTES_VIEW = 'NOTES_VIEW',
    NOTES_CREATE = 'NOTES_CREATE',
    NOTES_EDIT = 'NOTES_EDIT',
    NOTES_DELETE = 'NOTES_DELETE',
    NOTES_COMPLETE = 'NOTES_COMPLETE',
    PRODUCTS_VIEW = 'PRODUCTS_VIEW',
    PRODUCTS_CREATE = 'PRODUCTS_CREATE',
    PRODUCTS_EDIT = 'PRODUCTS_EDIT',
    PRODUCTS_DELETE = 'PRODUCTS_DELETE',
    SALES_VIEW = 'SALES_VIEW',
    SALES_CREATE = 'SALES_CREATE',
    SALES_EDIT = 'SALES_EDIT',
    SALES_DELETE = 'SALES_DELETE',
    MEMBER_PAYMENTS_VIEW = 'MEMBER_PAYMENTS_VIEW',
    MEMBER_PAYMENTS_CREATE = 'MEMBER_PAYMENTS_CREATE',
    MEMBER_PAYMENTS_EDIT = 'MEMBER_PAYMENTS_EDIT',
    MEMBER_PAYMENTS_DELETE = 'MEMBER_PAYMENTS_DELETE',
    BUSINESS_PAYMENTS_VIEW = 'BUSINESS_PAYMENTS_VIEW',
    INCOME_VIEW = 'INCOME_VIEW',
    BILLING_VIEW = 'BILLING_VIEW',
    MESSAGES_VIEW = 'MESSAGES_VIEW',
    MESSAGES_SEND = 'MESSAGES_SEND',
    SETTINGS_VIEW = 'SETTINGS_VIEW',
    SETTINGS_EDIT = 'SETTINGS_EDIT',
    STAFF_VIEW = 'STAFF_VIEW',
    STAFF_CREATE = 'STAFF_CREATE',
    STAFF_EDIT = 'STAFF_EDIT',
    STAFF_DELETE = 'STAFF_DELETE',
    STAFF_ATTENDANCE_VIEW = 'STAFF_ATTENDANCE_VIEW',
    STAFF_ATTENDANCE_MARK = 'STAFF_ATTENDANCE_MARK',
    STAFF_ATTENDANCE_EDIT = 'STAFF_ATTENDANCE_EDIT',
    STAFF_ATTENDANCE_DELETE = 'STAFF_ATTENDANCE_DELETE',
    ROLES_VIEW = 'ROLES_VIEW',
    ROLES_CREATE = 'ROLES_CREATE',
    ROLES_EDIT = 'ROLES_EDIT',
    ROLES_DELETE = 'ROLES_DELETE',
    BIOMETRIC_DEVICE_VIEW = 'BIOMETRIC_DEVICE_VIEW',
    BIOMETRIC_DEVICE_CREATE = 'BIOMETRIC_DEVICE_CREATE',
    BIOMETRIC_DEVICE_EDIT = 'BIOMETRIC_DEVICE_EDIT',
    BIOMETRIC_DEVICE_DELETE = 'BIOMETRIC_DEVICE_DELETE',
}

export enum BiometricTransactionProcessingStatus {
    PENDING = 'PENDING',
    PROCESSED = 'PROCESSED',
    FAILED = 'FAILED',
}